import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SettingDto } from '../../models/request.dto';
import { RequestService } from '../../services/request.service';
import { DesignAngularKitModule, ItNotificationService, NotificationPosition } from 'design-angular-kit';
import { FormsModule } from '@angular/forms';
import { FormDto } from '../../models/form.dto';
import { SystemService } from '../../services/system.sevice';

@Component({
  selector: 'app-monitor',
  standalone: true,
  imports: [DesignAngularKitModule,
    FormsModule,
    CommonModule,],
  templateUrl: './monitor.component.html',
  styleUrl: './monitor.component.scss'
})
export class MonitorComponent {

  data: any | undefined;

  constructor(
    private systemService: SystemService,
    private notification: ItNotificationService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.systemService
      .getMonitoring()
      .subscribe((response) => {
        if (response) {
          this.data = response;
        }
      });
  }

}
